var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { connect } from 'react-redux';
import * as classNames from 'classnames';
import Grow from '@material-ui/core/Grow';
import Apps from '@material-ui/icons/Apps';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import grey from '@material-ui/core/colors/grey';
import { sortBy, includes, delay } from 'lodash';
import { Icon, Avatar } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles } from '@material-ui/core/styles';
import { Manager, Target, Popper } from 'react-popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { getInitials } from 'src/utils/common';
import RouterLink from '../../reusable/RouterLink';
import { getTranslation } from 'src/translation';
var menuItemHeight = 48;
var menuItemCount = 12;
var styles = function (theme) { return ({
    root: {
        display: 'flex',
        marginLeft: 10,
        marginTop: 5,
    },
    paper: {
        marginRight: theme.spacing.unit * 2,
    },
    popperClose: {
        pointerEvents: 'none',
    },
    dropdown: {
        display: 'flex',
        backgroundColor: 'white',
        boxShadow: 'none',
        '-ms-overflow-style': 'none',
    },
    iconSmall: {
        fontSize: 45,
        paddingRight: 5,
        '@media(max-width: 1200px)': {
            fontSize: 40,
        },
    },
    channelsMenu: {
        marginLeft: -100,
        '& a + div': {
            opacity: 0,
            pointerEvents: 'none',
        },
        '& a:hover + div': {
            pointerEvents: 'unset',
            opacity: 1,
        },
        '& a:hover': {
            pointerEvents: 'unset',
            opacity: 1,
        },
        '& div:hover': {
            pointerEvents: 'unset',
            opacity: 1,
        },
        '@media(max-height: 672px)': {
            marginTop: 62,
        },
    },
    selectText: {
        '@media(max-width: 1200px)': {
            fontSize: 14,
        },
    },
    channelWrapper: {
        opacity: '1 !important',
        position: 'relative',
        backgroundColor: 'white',
    },
    nestedPopper: {
        transform: 'none !important',
        left: '100% !important',
    },
    menuWrapper: {
        border: '1px #e0e0e0 solid',
    },
    menu: {
        width: 343,
        height: menuItemCount * menuItemHeight,
        maxHeight: menuItemCount * menuItemHeight,
        'overflow-x': 'hidden',
        paddingTop: 0,
    },
    menuLink: {
        display: 'flex',
        width: '100% !important',
        color: 'rgb(3,3,3) !important',
        '&:hover': {
            textDecoration: 'none !important',
        },
    },
    channelItem: {
        color: '#F2F2F2',
        paddingLeft: 10,
        paddingRight: 10,
    },
    scrollIcon: {
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    selectButton: {
        padding: '8px 12px',
        width: 187,
        fontWeight: 500,
        '@media(max-width: 767px)': {
            width: 187,
        },
    },
    channelName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    channelImg: {
        width: 22,
        fontSize: 12,
        height: 23,
        maxWidth: '100%',
        marginRight: 12,
    },
    channelPreloader: {
        width: 22,
        height: 23,
        marginRight: 10,
        maxWidth: '100%',
        backgroundColor: '#cccccc',
    },
    sharedText: {
        position: 'absolute',
        top: 2,
        right: 35,
        background: theme.palette.primary.main,
        borderRadius: 10,
        textAlign: 'center',
        color: 'white',
        width: 50,
        fontWeight: 600,
        fontSize: 12,
    },
}); };
var MenuListComposition = /** @class */ (function (_super) {
    __extends(MenuListComposition, _super);
    function MenuListComposition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eventStack = [];
        _this.state = {
            open: false,
            selectedChannels: [],
            scrolledMenus: {},
        };
        _this.getChannels = function (parentId) {
            return sortBy((_this.props.channels || []).filter(function (channel) { return channel.parent === parentId; }), 'name');
        };
        _this.handleOpen = function () {
            _this.setState({ open: true, selectedChannels: [] });
        };
        _this.handleClose = function () {
            _this.setState({ open: false, selectedChannels: [] });
        };
        _this.setSelectedChannels = function () {
            if (_this.eventStack.length !== 0) {
                var lastEvent = _this.eventStack[_this.eventStack.length - 1];
                _this.setState({
                    selectedChannels: __spreadArray(__spreadArray([], _this.state.selectedChannels.slice(0, lastEvent.depth)), [lastEvent.id]),
                });
                _this.eventStack = [];
            }
        };
        _this.onSelectChannel = function (channelId, depth) { return function () {
            _this.eventStack = __spreadArray(__spreadArray([], _this.eventStack), [{ id: channelId, depth: depth }]);
            delay(_this.setSelectedChannels, 10);
        }; };
        _this.onScrollDown = function (depth) { return function () {
            var _a;
            var element = document.getElementById("scroll-menu-" + depth);
            var scrollTo = menuItemHeight + (_this.state.scrolledMenus["depth-" + depth] || 0);
            if (scrollTo > element.scrollHeight - menuItemHeight * (menuItemCount - 1)) {
                return;
            }
            element.scrollTop = scrollTo;
            _this.setState({
                scrolledMenus: __assign(__assign({}, _this.state.scrolledMenus), (_a = {}, _a["depth-" + depth] = scrollTo, _a)),
            });
        }; };
        _this.onScrollUp = function (depth) { return function () {
            var _a;
            var element = document.getElementById("scroll-menu-" + depth);
            var scrollTo = _this.state.scrolledMenus["depth-" + depth] - menuItemHeight;
            element.scrollTop = scrollTo;
            _this.setState({
                scrolledMenus: __assign(__assign({}, _this.state.scrolledMenus), (_a = {}, _a["depth-" + depth] = scrollTo, _a)),
            });
        }; };
        return _this;
    }
    MenuListComposition.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, classes = _b.classes, loading = _b.loading, translate = _b.translate, tubeColor = _b.tubeColor;
        var _c = this.state, open = _c.open, selectedChannels = _c.selectedChannels, scrolledMenus = _c.scrolledMenus;
        var getChannelName = function (channel) {
            var isExpandable = channel.shared || (_this.props.sharedChannelsToOthers || []).some(function (item) { return item.channelId === channel.id; });
            return (React.createElement(React.Fragment, null, (isExpandable ? (channel.name.length > 26) : (channel.name.length > 31)) ? (React.createElement(Tooltip, { title: channel.name },
                React.createElement("div", { style: includes(_this.state.selectedChannels, channel.id)
                        ? __assign({ color: 'white' }, (isExpandable ? { width: '65%' } : {})) : __assign({}, (isExpandable ? { width: '65%' } : {})), className: classes.channelName }, channel.name))) : (React.createElement("div", { style: includes(_this.state.selectedChannels, channel.id)
                    ? __assign({ color: 'white' }, (isExpandable ? { width: '65%' } : {})) : __assign({}, (isExpandable ? { width: '65%' } : {})), className: classes.channelName }, channel.name))));
        };
        var rootChannelsToShow = this.getChannels(localStorage.getItem('tubeId'));
        var channelWithNoParent = (this.props.channels || [])
            .filter(function (item) { return item.parent !== localStorage.getItem('tubeId'); })
            .filter(function (item) {
            var hasParentInList = _this.props.channels.find(function (channel) { return channel.id === item.parent; });
            return !hasParentInList;
        });
        var channelsToShow = __spreadArray(__spreadArray([], rootChannelsToShow), channelWithNoParent);
        return (React.createElement("div", { className: classes.root },
            React.createElement(Manager, null,
                React.createElement(Target, null,
                    React.createElement("div", null,
                        React.createElement(Button, { id: "select-channel-btn", className: classes.selectButton, "aria-owns": open ? 'menu-list-grow' : null, "aria-haspopup": "true", onClick: this.handleOpen },
                            React.createElement("span", { className: classes.selectText },
                                " ",
                                translate('selectChannel')),
                            React.createElement(Apps, { className: classNames(classes.leftIcon, classes.iconSmall) })))),
                open && (React.createElement(Popper, { placement: "bottom-start", eventsEnabled: open, className: classNames((_a = {}, _a[classes.popperClose] = !open, _a), classes.channelsMenu) },
                    React.createElement(ClickAwayListener, { onClickAway: this.handleClose },
                        React.createElement(Grow, { in: open, style: { transformOrigin: '0 0 0' } },
                            React.createElement(Paper, { className: classNames(classes.dropdown) }, loading ? (translate('loading')) : (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: classes.menuWrapper },
                                    scrolledMenus['depth-0'] ? (React.createElement("div", { className: classes.scrollIcon, onClick: this.onScrollUp(0) },
                                        React.createElement(Icon, null, "expand_less"))) : null,
                                    React.createElement(MenuList, { id: "scroll-menu-0", role: "menu", className: classNames('channels-menu', classes.menu) }, channelsToShow.map(function (channel) { return (React.createElement(MenuItem, { key: channel.id, className: classes.channelItem, style: includes(_this.state.selectedChannels, channel.id) ? { background: tubeColor } : {}, onMouseEnter: _this.onSelectChannel(channel.id, 0) },
                                        React.createElement(RouterLink, { id: "channel-" + (channel.name || '').replace(/\s{1,}/g, '-') + "-link", name: channel.name, to: "/channel/" + channel.id + "/home", className: classes.menuLink, onClick: _this.handleClose },
                                            loading ? (React.createElement(Avatar, { className: classes.channelPreloader })) : channel.channelIcon ? (React.createElement("img", { className: classes.channelImg, src: channel.channelIcon })) : (React.createElement(Avatar, { style: includes(_this.state.selectedChannels, channel.id)
                                                    ? {
                                                        backgroundColor: 'white',
                                                        color: tubeColor,
                                                    }
                                                    : {
                                                        backgroundColor: tubeColor,
                                                        color: 'white',
                                                    }, className: classes.channelImg }, getInitials(channel.name))),
                                            getChannelName(channel),
                                            React.createElement("div", { className: classes.sharedText, style: includes(_this.state.selectedChannels, channel.id)
                                                    ? {
                                                        background: 'white',
                                                        color: tubeColor,
                                                    }
                                                    : {} }, translate(channel.shared
                                                ? 'external'
                                                : _this.props.sharedChannelsToOthers.some(function (item) { return item.channelId === channel.id; })
                                                    ? 'shared'
                                                    : '')),
                                            _this.getChannels(channel.id).length ? (React.createElement(Icon, { style: includes(_this.state.selectedChannels, channel.id)
                                                    ? { marginLeft: 'auto', color: 'white' }
                                                    : { marginLeft: 'auto' } }, "chevron_right")) : null))); })),
                                    this.getChannels(localStorage.getItem('tubeId')).length > menuItemCount ? (React.createElement("div", { className: classes.scrollIcon, onClick: this.onScrollDown(0) },
                                        React.createElement(Icon, null, "expand_more"))) : null),
                                selectedChannels.length
                                    ? selectedChannels.map(function (selectedChannel, index) {
                                        return _this.getChannels(selectedChannel).length ? (React.createElement("div", { key: selectedChannel, className: classes.menuWrapper, style: {
                                                backgroundColor: grey[(index + 1) * 50],
                                            } },
                                            scrolledMenus["depth-" + (index + 1)] ? (React.createElement("div", { className: classes.scrollIcon, onClick: _this.onScrollUp(index + 1) },
                                                React.createElement(Icon, null, "expand_less"))) : null,
                                            React.createElement(MenuList, { id: "scroll-menu-" + (index + 1), role: "menu", className: classNames('channels-menu', classes.menu) }, _this.getChannels(selectedChannel).map(function (channel) { return (React.createElement(MenuItem, { key: channel.id, className: classes.channelItem, onMouseEnter: _this.onSelectChannel(channel.id, index + 1), style: includes(_this.state.selectedChannels, channel.id)
                                                    ? { background: tubeColor }
                                                    : {} },
                                                React.createElement(RouterLink, { id: "selected-channel-" + (channel.name || '').replace(/\s{1,}/g, '-') + "-link", name: channel.name, to: "/channel/" + channel.id + "/home", className: classes.menuLink, onClick: _this.handleClose },
                                                    loading ? (React.createElement(Avatar, { className: classes.channelPreloader })) : channel.channelIcon ? (React.createElement("img", { className: classes.channelImg, src: channel.channelIcon })) : (React.createElement(Avatar, { style: includes(_this.state.selectedChannels, channel.id)
                                                            ? {
                                                                backgroundColor: 'white',
                                                                color: tubeColor,
                                                            }
                                                            : {
                                                                backgroundColor: tubeColor,
                                                                color: 'white',
                                                            }, className: classes.channelImg }, getInitials(channel.name))),
                                                    getChannelName(channel),
                                                    React.createElement("div", { className: classes.sharedText, style: includes(_this.state.selectedChannels, channel.id)
                                                            ? {
                                                                background: 'white',
                                                                color: tubeColor,
                                                            }
                                                            : {} }, translate(channel.shared
                                                        ? 'external'
                                                        : _this.props.sharedChannelsToOthers.some(function (item) { return item.channelId === channel.id; })
                                                            ? 'shared'
                                                            : '')),
                                                    _this.getChannels(channel.id).length ? (React.createElement(Icon, { style: includes(_this.state.selectedChannels, channel.id)
                                                            ? { marginLeft: 'auto', color: 'white' }
                                                            : { marginLeft: 'auto' } }, "chevron_right")) : null))); })),
                                            _this.getChannels(selectedChannel).length > menuItemCount ? (React.createElement("div", { id: "expand-more-icon", className: classes.scrollIcon, onClick: _this.onScrollDown(index + 1) },
                                                React.createElement(Icon, null, "expand_more"))) : null)) : null;
                                    })
                                    : null))))))))));
    };
    return MenuListComposition;
}(React.PureComponent));
var mapStateToProps = function (state) { return ({
    translate: getTranslation(state.translation.lang),
    tubeColor: state.auth.tube.color,
    orgId: state.auth.organization.id,
    sharedChannelsToOthers: state.auth.organization.sharedChannelsToOthers || [],
}); };
// @ts-ignore
export default withStyles(styles)(connect(mapStateToProps)(MenuListComposition));



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/ChannelList.tsx
// module id = 2035
// module chunks = 81